import { FC } from 'react';
import { StyledHeaderContainer, StyledHeader, StyledLogo } from './Header.style';
import HeaderDropdownNav from '../HeaderDropdownNav/HeaderDropdownNav';
import { Link } from '@base-app';
import { PATHS } from '@constants/routes';

const Header: FC = () => {
  return (
    <StyledHeaderContainer>
      <StyledHeader>
        <Link to={PATHS.ROOT}>
          <StyledLogo />
        </Link>
        <HeaderDropdownNav />
      </StyledHeader>
    </StyledHeaderContainer>
  );
};

export default Header;
